import { Icon } from "@/components/site/Icon";

/**
 * Content + Aside layout: heading + long body paragraphs on the left (8 cols),
 * sticky summary card on the right (4 cols).
 * Matches reference "What this service delivers" style.
 */
export default function ContentAside({ section }) {
  const { eyebrow, heading, paragraphs = [], cards = [], theme = "white" } = section;
  const aside = cards[0];
  const bgClass = theme === "navy" ? "bg-mist-navy text-white" : theme === "off" ? "bg-mist-off" : "bg-white";
  const headingColor = theme === "navy" ? "text-white" : "text-mist-navy";
  const paraColor = theme === "navy" ? "text-white/80" : "text-mist-ink/80";

  return (
    <section className={`${bgClass} py-24 lg:py-32`}>
      <div className="container-mist grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-8">
          <div className="max-w-2xl text-left">
            {heading && (
              <h2
                className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight ${headingColor}`}
              >
                {heading}
              </h2>
            )}
            {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
          </div>
          <div className={`mt-6 space-y-5 text-[15px] leading-relaxed ${paraColor}`}>
            {paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
        {aside && (
          <aside className="lg:col-span-4">
            <div className="bg-mist-navy text-white rounded-md p-8 sticky top-24">
              {aside.icon && <Icon name={aside.icon} className="h-6 w-6 text-mist-gold mb-4" />}
              {aside.title && <div className="font-sans font-semibold text-xl leading-snug tracking-tight">{aside.title}</div>}
              {aside.description && (
                <p className="mt-4 text-sm text-white/80 leading-relaxed">{aside.description}</p>
              )}
            </div>
          </aside>
        )}
      </div>
    </section>
  );
}
